import type { ButtonHTMLAttributes, ReactNode } from "react";
import { forwardRef } from "react";
import type { GameId } from "@shared/types";
import { haptic, play, type SfxName } from "../lib/sfx";

type Variant = "candy" | "flame" | "ink" | "soft" | "good" | "ghost";
type GameKey = GameId | "joker" | "guess";

export interface BtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  game?: GameKey;
  size?: "sm" | "md" | "lg";
  block?: boolean;
  sound?: SfxName | null;
  icon?: ReactNode;
}

const GAME_INK: Record<GameKey, string> = {
  bluff: "#fff",
  spy: "#132100",
  match: "#2a0022",
  truf: "#00243a",
  joker: "#2b1d00",
  guess: "#2a0f00",
};

export const Btn = forwardRef<HTMLButtonElement, BtnProps>(function Btn(
  { variant = "candy", game, size = "md", block, sound = "tap", icon, className = "", style, onClick, children, ...rest },
  ref,
) {
  const cls = [
    "btn",
    variant !== "candy" && !game ? `btn-${variant}` : "",
    size === "sm" ? "btn-sm" : size === "lg" ? "btn-lg" : "",
    block ? "btn-block" : "",
    className,
  ].join(" ");
  const gameStyle = game
    ? ({ "--b": `var(--color-${game})`, "--s": `var(--color-${game}-deep)`, "--i": GAME_INK[game] } as React.CSSProperties)
    : undefined;
  return (
    <button
      ref={ref}
      type="button"
      className={cls}
      style={{ ...gameStyle, ...style }}
      onClick={(e) => {
        if (sound) play(sound);
        haptic(8);
        onClick?.(e);
      }}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
});
